import { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'

export default function Login() {
  const { signInWithMicrosoft } = useAuth()
  const [error, setError] = useState('')
  const [msLoading, setMsLoading] = useState(false)

  const handleMicrosoft = async () => {
    setError('')
    setMsLoading(true)

    try {
      const { error } = await signInWithMicrosoft()

      if (error) throw error
      // On success the browser redirects to Microsoft; the session is picked
      // up on return via detectSessionInUrl + onAuthStateChange.
    } catch (error) {
      setError(error.message)
      setMsLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-500 to-secondary-500 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
        <div className="bg-gradient-to-r from-primary-500 to-secondary-500 dark:from-gray-700 dark:to-gray-600 p-8 text-white text-center">
          <h1 className="text-3xl font-bold mb-2">Welcome Back</h1>
          <p className="text-primary-100 dark:text-gray-300">Nudgge Admin Interface</p>
        </div>

        <div className="p-8">
          {error && (
            <div className="mb-4 p-3 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-300 rounded-lg text-sm">
              {error}
            </div>
          )}

          <p className="mb-6 text-center text-sm text-gray-600 dark:text-gray-400">
            Sign in with your organisation Microsoft account.
          </p>

          <button
            type="button"
            onClick={handleMicrosoft}
            disabled={msLoading}
            className="w-full flex items-center justify-center gap-3 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 py-3 px-4 rounded-lg font-semibold hover:bg-gray-50 dark:hover:bg-gray-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg viewBox="0 0 21 21" width="18" height="18" aria-hidden="true" className="shrink-0">
              <rect x="1" y="1" width="9" height="9" fill="#f25022" />
              <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
              <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </svg>
            {msLoading ? 'Redirecting to Microsoft…' : 'Sign in with Microsoft'}
          </button>
        </div>

        <div className="px-8 py-4 bg-gray-50 dark:bg-gray-700 border-t border-gray-100 dark:border-gray-600 text-center text-xs text-gray-500 dark:text-gray-400">
          Secure admin access to Nudgge microservices
        </div>
      </div>
    </div>
  )
}
